document.addEventListener('DOMContentLoaded', () => {
    const modalVariants = document.querySelectorAll('.modal-variants');
    const modalVariantsButtons = document.querySelectorAll('.product-variant-button');
    const fixedSection = document.getElementById('fixedSection');
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const isDesktop1024 = window.matchMedia('(min-width: 1024px)').matches;

    const quantityButton = document.querySelector('.quantity-main-product');
    const fixedBanner = document.querySelector('.fixed-section');

    window.addEventListener('scroll', (e) => {
        if (fixedBanner) {
            const topDistance = quantityButton?.getBoundingClientRect()?.top;

            if (topDistance > -50) {
                closeAllModals()
            }
        }
    });

    const closeAllModals = () => {
        modalVariants.forEach(modal => {
            if (modal.classList.contains('modal-variants--open')) {
                closeModal(modal);
            }
        });
    };

    const closeModal = (modalVariant) => {
        if (!modalVariant) return;
        
        modalVariant.style.left = isDesktop ? '100vw' : '0';
        modalVariant.style.bottom = isDesktop ? '0' : '-100vh';
        modalVariant.classList.remove('modal-variants--open');
    };

    const openModal = (modalVariant, openPosition) => {
        closeAllModals();
        
        if (isDesktop1024) {
            modalVariant.style.left = '65vw';
        } else if (isDesktop) {
            modalVariant.style.left = '50vw';
        } else {
            modalVariant.style.left = '0';
            setTimeout(() => {
                modalVariant.style.bottom = `${openPosition - 28}px`;
            }, 10);
        }

        modalVariant.classList.add('modal-variants--open');
    };

    const handleButtonClick = (event) => {
        event.stopPropagation();
        
        const button = event.currentTarget;
        const modalVariant = document.querySelector(`.modal-variants[data-modal="${button.getAttribute('data-modal')}"]`);
        const fixedSectionHeight = fixedSection.getBoundingClientRect().height;

        if (!modalVariant) return;
        
        if (modalVariant.classList.contains('modal-variants--open')) {
            closeModal(modalVariant);
        } else {
            openModal(modalVariant, fixedSectionHeight);
        }
    };

    const handleCloseButtonClick = (event) => {
        closeModal(event.target.closest('.modal-variants'));
    };

    const handleGlobalClick = (event) => {
        const isClickInsideFixedSection = fixedSection.contains(event.target);
        const isClickInsideModal = [...modalVariants].some(modal => modal.contains(event.target));
        
        if (!isClickInsideFixedSection && !isClickInsideModal) {
            closeAllModals();
        }
    };

    modalVariantsButtons.forEach(button => button.addEventListener('click', handleButtonClick));
    document.querySelectorAll('.modal-variants__close').forEach(close => close.addEventListener('click', handleCloseButtonClick));
    document.addEventListener('click', handleGlobalClick);
});